"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMortgageRefinancingOutputs = void 0;
var init_1 = require("../states/init");
var MortgageInsuranceTable_init_1 = require("../states/MortgageInsuranceTable.init");
var MortgageLimitTable_init_1 = require("../states/MortgageLimitTable.init");
var getMortgageOutputs_1 = require("./getMortgageOutputs");
exports.getMortgageRefinancingOutputs = function (refinanceInput) {
    var outstandingMortgage = refinanceInput.outstandingMortgage, currentTenor = refinanceInput.currentTenor, existingInterestRate = refinanceInput.existingInterestRate, newPropertyValue = refinanceInput.newPropertyValue, newLoan = refinanceInput.newLoan, newTenor = refinanceInput.newTenor, newInterestRate = refinanceInput.newInterestRate, specialStampDutyRateTable = refinanceInput.specialStampDutyRateTable, doubleAdValoremStampDutyRateTable = refinanceInput.doubleAdValoremStampDutyRateTable;
    var currentDownPayment = newPropertyValue - outstandingMortgage;
    var currentnputs = {
        isInsuranceMonthlyRepay: init_1.defaultMortgageCommonInput.isInsuranceMonthlyRepay,
        legalAmount: init_1.defaultMortgageCommonInput.legalAmount,
        propertyValue: newPropertyValue,
        downPayment: currentDownPayment,
        tenor: currentTenor,
        interestRate: existingInterestRate,
        buyerStampDutyRate: init_1.defaultMortgageCommonInput.buyerStampDutyRate,
        adValoremStampDutyRate: init_1.defaultMortgageCommonInput.adValoremStampDutyRate,
        commissionRate: init_1.defaultMortgageCommonInput.commissionRate,
        buyerStampDuty: init_1.defaultMortgageCommonInput.buyerStampDuty,
        adValoremStampDuty: init_1.defaultMortgageCommonInput.adValoremStampDuty,
        hasOutstandingMortgage: init_1.defaultMortgageCommonInput.hasOutstandingMortgage,
        lastTransactionInMonth: init_1.defaultMortgageCommonInput.lastTransactionInMonth,
        specialStampDutyRateTable: specialStampDutyRateTable,
        doubleAdValoremStampDutyRateTable: doubleAdValoremStampDutyRateTable,
        mortgagePlanList: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycle,
        mortgagePlanListWithProperty: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycleWithProperty,
        mortgageLimitTable: MortgageLimitTable_init_1.defaultMortgageLimitTable,
        rateTableInputs: init_1.defaultMortgageRateTableInput
    };
    var currentOutputs = getMortgageOutputs_1.getMortgageOutputs(currentnputs);
    var newMortgage = newLoan;
    var newDownPayment = newPropertyValue - newMortgage;
    var newInputs = {
        isInsuranceMonthlyRepay: init_1.defaultMortgageCommonInput.isInsuranceMonthlyRepay,
        legalAmount: init_1.defaultMortgageCommonInput.legalAmount,
        propertyValue: newPropertyValue,
        downPayment: newDownPayment,
        tenor: newTenor,
        interestRate: newInterestRate,
        buyerStampDutyRate: init_1.defaultMortgageCommonInput.buyerStampDutyRate,
        adValoremStampDutyRate: init_1.defaultMortgageCommonInput.adValoremStampDutyRate,
        hasOutstandingMortgage: init_1.defaultMortgageCommonInput.hasOutstandingMortgage,
        commissionRate: init_1.defaultMortgageCommonInput.commissionRate,
        buyerStampDuty: init_1.defaultMortgageCommonInput.buyerStampDuty,
        adValoremStampDuty: init_1.defaultMortgageCommonInput.adValoremStampDuty,
        lastTransactionInMonth: init_1.defaultMortgageCommonInput.lastTransactionInMonth,
        specialStampDutyRateTable: specialStampDutyRateTable,
        doubleAdValoremStampDutyRateTable: doubleAdValoremStampDutyRateTable,
        mortgagePlanList: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycle,
        mortgagePlanListWithProperty: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycleWithProperty,
        mortgageLimitTable: MortgageLimitTable_init_1.defaultMortgageLimitTable,
        rateTableInputs: init_1.defaultMortgageRateTableInput
    };
    var newOutputs = getMortgageOutputs_1.getMortgageOutputs(newInputs);
    var cashOut = newMortgage - outstandingMortgage;
    return {
        cashout: cashOut > 0 ? cashOut : 0,
        newMonthlyRepayment: newOutputs.monthlyPayment,
        newTotalInterest: newOutputs.totalInterest,
        existingMonthlyRepayment: currentOutputs.monthlyPayment,
        existingTotalInterest: currentOutputs.totalInterest,
        error: newOutputs.error
    };
};
